/* qb-reviews.js — Verhalten der Bewertungs-Slider (kuratiert + live Google)
   Gebaut 2026-08-07, Job 20260807-qi-blanco-footer-fix-deploy-plus-reviews-neubau-liquid.
   Vorbild: DACH ReviewsSlider (Drag/Autoscroll/IntersectionObserver, GL-DES-0012).

   Zwei oeffentliche Einstiege:
     QBReviews.initTrack(trackEl)   -> Drag + Autoscroll + "read more" auf bestehende Karten
     QBReviews.renderLive(rootEl)   -> Reputon-Feed holen, Karten bauen, dann initTrack

   Nutzertext wird AUSSCHLIESSLICH per textContent gesetzt (keine HTML-Injektion).

   KUNDENFOTOS (ergaenzt 2026-08-08, Job …-kundenfotos-konzept-s02, Vorbild ist
   die DACH-Umsetzung aus s01): das Feed-Feld `images` wurde bisher beim
   Normalisieren weggeworfen, deshalb zeigte der Eigenbau keine Kundenfotos —
   das alte Reputon-Client-Widget zeigte sie. Zwei Felder, die man nie
   verwechseln darf: `foto` = profilePhotoUrl = AVATAR des Verfassers (37/37),
   `bilder` = images = die vom Kunden GEPOSTETEN Fotos (3/37). */
(function () {
  'use strict';
  if (window.QBReviews) return; // Init-Riegel: Asset kann von zwei Sektionen geladen werden

  var AUTOSCROLL_MS = 4000;
  var START_DELAY_MS = 3000;
  var VISIBLE_THRESHOLD = 0.4;
  var PROGRAMMATIC_MS = 1500;
  var MAX_BILDER = 3;      // mehr wird als "+n" gezaehlt, nicht gezeigt
  var THUMB_PX = 112;      // 2x fuer 56 px Anzeige (Retina)

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  /* ---------- Sterne (fraktional, clip-basiert = SSR-/ID-frei) ---------- */
  var STAR_PATH = 'M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z';

  function starSvg(size, color) {
    var ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('width', size); svg.setAttribute('height', size);
    svg.setAttribute('viewBox', '0 0 24 24'); svg.setAttribute('aria-hidden', 'true');
    var p = document.createElementNS(ns, 'path');
    p.setAttribute('d', STAR_PATH); p.setAttribute('fill', color);
    svg.appendChild(p);
    return svg;
  }

  function starRow(value, size) {
    var row = el('span', 'qbr__starrow');
    for (var i = 0; i < 5; i++) {
      var share = Math.max(0, Math.min(1, value - i));
      var wrap = el('span');
      wrap.style.position = 'relative';
      wrap.style.display = 'inline-block';
      wrap.style.width = size + 'px';
      wrap.style.height = size + 'px';
      wrap.appendChild(starSvg(size, 'var(--qbr-star-off)'));
      if (share > 0) {
        var fg = el('span');
        fg.style.position = 'absolute';
        fg.style.top = '0'; fg.style.left = '0';
        fg.style.height = '100%';
        fg.style.width = (share * 100) + '%';
        fg.style.overflow = 'hidden';
        fg.appendChild(starSvg(size, 'var(--qbr-star)'));
        wrap.appendChild(fg);
      }
      row.appendChild(wrap);
    }
    row.setAttribute('role', 'img');
    row.setAttribute('aria-label', value.toFixed(1).replace('.0', '') + ' out of 5 stars');
    return row;
  }

  function googleIcon(size) {
    var ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('width', size); svg.setAttribute('height', size);
    svg.setAttribute('viewBox', '0 0 48 48'); svg.setAttribute('aria-hidden', 'true');
    var paths = [
      ['#FFC107', 'M43.611 20.083H42V20H24v8h11.303c-1.649 4.657-6.08 8-11.303 8-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 12.955 4 4 12.955 4 24s8.955 20 20 20 20-8.955 20-20c0-1.341-.138-2.65-.389-3.917z'],
      ['#FF3D00', 'M6.306 14.691l6.571 4.819C14.655 15.108 18.961 12 24 12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 16.318 4 9.656 8.337 6.306 14.691z'],
      ['#4CAF50', 'M24 44c5.166 0 9.86-1.977 13.409-5.192l-6.19-5.238A11.91 11.91 0 0 1 24 36c-5.202 0-9.619-3.317-11.283-7.946l-6.522 5.025C9.505 39.556 16.227 44 24 44z'],
      ['#1976D2', 'M43.611 20.083H42V20H24v8h11.303a12.04 12.04 0 0 1-4.087 5.571l.003-.002 6.19 5.238C36.971 39.205 44 34 44 24c0-1.341-.138-2.65-.389-3.917z']
    ];
    paths.forEach(function (pr) {
      var p = document.createElementNS(ns, 'path');
      p.setAttribute('fill', pr[0]); p.setAttribute('d', pr[1]);
      svg.appendChild(p);
    });
    return svg;
  }

  function verifyIcon(size) {
    var ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('width', size); svg.setAttribute('height', size);
    svg.setAttribute('viewBox', '0 0 24 24'); svg.setAttribute('aria-hidden', 'true');
    var p = document.createElementNS(ns, 'path');
    p.setAttribute('fill', 'var(--qbr-verify)');
    p.setAttribute('d', 'M12 2l2.4 1.8 3-.2 1 2.8 2.6 1.5-1 2.8 1 2.8-2.6 1.5-1 2.8-3-.2L12 22l-2.4-1.8-3 .2-1-2.8L3 16.1l1-2.8-1-2.8 2.6-1.5 1-2.8 3 .2L12 2zm-1.2 13.6l5.7-5.7-1.4-1.4-4.3 4.3-2-2-1.4 1.4 3.4 3.4z');
    svg.appendChild(p);
    return svg;
  }

  /* ---------- Kundenfoto-Thumbnail ----------
     Der Feed liefert `thumbnailUrl` IDENTISCH zur Vollbild-`url` — der Feldname
     ist kein Beleg fuer ein Thumbnail (gemessen 2026-08-08: 78 KB fuer ein
     56x56-Bild). Googles Groessensuffix macht daraus ~7,5 KB. Defensiv: nur
     googleusercontent-URLs, nur wenn wirklich ein "="-Suffix da ist; sonst
     bleibt die URL unangetastet. Idempotent (=s112-c -> =s112-c).
     Dasselbe Muster nutzt der Avatar bereits (…=s120-c-rp-mo-br100). */
  function bildThumbUrl(url, groesse) {
    if (typeof url !== 'string' || url.indexOf('googleusercontent.com/') === -1) return url;
    var schnitt = url.lastIndexOf('=');
    if (schnitt <= url.lastIndexOf('/')) return url; // kein Suffix -> nicht anfassen
    return url.slice(0, schnitt) + '=s' + (groesse || THUMB_PX) + '-c';
  }

  /* ---------- "read more" ---------- */
  function wireReadMore(card, labelMore, labelLess) {
    var text = card.querySelector('.qbr__text');
    var btn = card.querySelector('.qbr__more');
    if (!text || !btn) return;
    // Nur anbieten, wenn der Text bei 6 Zeilen wirklich ueberlaeuft.
    if (text.scrollHeight <= text.clientHeight + 4) { btn.hidden = true; return; }
    btn.hidden = false;
    btn.textContent = labelMore;
    btn.addEventListener('click', function () {
      var open = text.classList.toggle('is-open');
      btn.textContent = open ? labelLess : labelMore;
    });
  }

  /* ---------- Drag + Autoscroll ---------- */
  function initTrack(track) {
    if (!track || track.dataset.qbrInit === '1') return;
    track.dataset.qbrInit = '1';

    var cards = track.querySelectorAll('.qbr__card');
    var more = track.getAttribute('data-label-more') || 'Read more';
    var less = track.getAttribute('data-label-less') || 'Show less';
    Array.prototype.forEach.call(cards, function (c) { wireReadMore(c, more, less); });

    /* --- Maus-Drag (Touch nutzt natives Scrollen) --- */
    var dragging = false, startX = 0, startLeft = 0, moved = false;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      dragging = true; moved = false;
      startX = e.clientX; startLeft = track.scrollLeft;
      track.classList.add('is-dragging');
    });
    window.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 3) moved = true;
      track.scrollLeft = startLeft - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!dragging) return;
      dragging = false;
      track.classList.remove('is-dragging');
    });
    // Ein Drag darf keinen Link/Button ausloesen.
    track.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);

    /* --- Autoscroll --- */
    if (track.getAttribute('data-autoplay') === 'false' || reducedMotion()) return;
    if (!('IntersectionObserver' in window)) return;

    var timer = null, startTimer = null, hovered = false, takenOver = false, progUntil = 0;

    function step() {
      if (hovered || dragging || takenOver) return;
      var card = track.querySelector('.qbr__card');
      if (!card) return;
      var stride = card.getBoundingClientRect().width + 20;
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      progUntil = Date.now() + PROGRAMMATIC_MS;
      track.scrollTo({ left: atEnd ? 0 : track.scrollLeft + stride, behavior: 'smooth' });
    }
    function start() {
      stop();
      startTimer = setTimeout(function () { timer = setInterval(step, AUTOSCROLL_MS); }, START_DELAY_MS);
    }
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
      if (startTimer) { clearTimeout(startTimer); startTimer = null; }
    }

    track.addEventListener('pointerenter', function () { hovered = true; });
    track.addEventListener('pointerleave', function () { hovered = false; });
    ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (ev) {
      track.addEventListener(ev, function () { takenOver = true; stop(); }, { passive: true });
    });
    // Eigenes programmatisches Scrollen darf die Uebernahme nicht ausloesen.
    track.addEventListener('scroll', function () {
      if (Date.now() < progUntil) return;
      takenOver = true; stop();
    }, { passive: true });

    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { if (!takenOver) start(); }
        else { takenOver = false; stop(); }
      });
    }, { threshold: VISIBLE_THRESHOLD }).observe(track);
  }

  /* ---------- Karte bauen ---------- */
  function buildCard(r, opts) {
    var card = el('div', 'qbr__card');

    var head = el('div', 'qbr__head');
    var who = el('div', 'qbr__who');
    if (r.foto) {
      var img = el('img', 'qbr__avatar');
      img.src = r.foto; img.alt = ''; img.setAttribute('role', 'presentation'); img.loading = 'lazy';
      img.referrerPolicy = 'no-referrer'; img.draggable = false;
      img.addEventListener('error', function () {
        var f = el('div', 'qbr__avatar qbr__avatar--initial', (r.name || '?').charAt(0).toUpperCase());
        img.replaceWith(f);
      });
      who.appendChild(img);
    } else {
      who.appendChild(el('div', 'qbr__avatar qbr__avatar--initial', (r.name || '?').charAt(0).toUpperCase()));
    }
    var meta = el('div', 'qbr__meta');
    meta.appendChild(el('p', 'qbr__name', r.name || ''));
    meta.appendChild(el('p', 'qbr__date', r.zeit || ''));
    who.appendChild(meta);
    head.appendChild(who);
    head.appendChild(googleIcon(20));
    card.appendChild(head);

    /* data-qb-rating="d" (Marker-Vertrag, Job 20260820-... s04): die Sterne
       einer EINZELNEN Karte tragen die Bewertung EINER Person, nicht die
       Gesamtbewertung — rein darstellend, ausdruecklich KEIN Trigger und kein
       Google-Link. Der Marker macht diese Absicht pruefbar: eine Sterne-Ansicht,
       die nichts tut, OHNE dass es irgendwo deklariert ist, ist eine Fehlstelle.
       Das statische Gegenstueck steht in build/gen_curated_section.py. */
    var stars = el('div', 'qbr__stars');
    stars.setAttribute('data-qb-rating', 'd');
    stars.appendChild(starRow(Number(r.rating) || 5, 16));
    stars.appendChild(verifyIcon(14));
    card.appendChild(stars);

    card.appendChild(el('p', 'qbr__text', r.text || ''));
    if (r.original) {
      /* Nur Arm b des Tests 'bewertung' (renderLive setzt `original` sonst nie):
         Kennzeichnung wie bisher, daneben der Knopf, darunter das Original
         eingeklappt. lang="de": die Uebersetzungen des US-Feeds kommen aus
         deutschsprachigen Rezensionen (09.10.: 31 von 31). Die Knopf-id
         macht den Klick im Klick-Protokoll des eigenen Pixels lesbar
         (Begleitsignal, TESTKONZEPT-ab-bewertung.md). */
      var zeile = el('p', 'qbr__translated', opts.labelTranslated + ' \u00b7 ');
      var knopf = el('button', 'qbr__original-knopf', opts.labelOriginalZeigen);
      var orig = el('p', 'qbr__original', r.original);
      orig.id = 'qbr-original-' + (++originalZaehler);
      knopf.id = 'qbr-original-knopf-' + originalZaehler;
      orig.setAttribute('lang', 'de');
      orig.hidden = true;
      knopf.type = 'button';
      knopf.setAttribute('aria-expanded', 'false');
      knopf.setAttribute('aria-controls', orig.id);
      knopf.addEventListener('click', function () {
        var auf = orig.hidden;
        orig.hidden = !auf;
        knopf.setAttribute('aria-expanded', auf ? 'true' : 'false');
        knopf.textContent = auf ? opts.labelOriginalVerbergen : opts.labelOriginalZeigen;
      });
      zeile.appendChild(knopf);
      card.appendChild(zeile);
      card.appendChild(orig);
    } else if (r.uebersetzt) card.appendChild(el('p', 'qbr__translated', opts.labelTranslated));

    /* Kundenfotos: die vom Kunden bei Google GEPOSTETEN Bilder (Feed-Feld
       `images` -> `bilder`) — NICHT der Avatar (`foto`) in der Kopfzeile.
       Nur 3 der 37 Rezensionen tragen welche; bei allen anderen entfaellt die
       Zeile ersatzlos. Feste width/height halten die Kartenhoehe stabil.
       Der Klick oeffnet das Bild gross in einem neuen Tab — die Drag-Sperre
       in initTrack (click-capture bei moved) faengt ihn nach einer echten
       Zieh-Geste ab, es braucht also kein eigenes Popup. */
    var bilder = Array.isArray(r.bilder) ? r.bilder : [];
    if (bilder.length) {
      var reihe = el('div', 'qbr__photos');
      bilder.slice(0, MAX_BILDER).forEach(function (b) {
        var a = el('a', 'qbr__photo');
        a.href = b.url; a.target = '_blank'; a.rel = 'noopener noreferrer';
        var pi = el('img', 'qbr__photo-img');
        pi.src = bildThumbUrl(b.thumb || b.url);
        pi.alt = (opts.labelPhotoAlt || 'Customer photo for the review by') + ' ' + (r.name || '');
        pi.width = 56; pi.height = 56;
        pi.loading = 'lazy'; pi.decoding = 'async';
        pi.referrerPolicy = 'no-referrer'; pi.draggable = false;
        a.appendChild(pi);
        reihe.appendChild(a);
      });
      if (bilder.length > MAX_BILDER) {
        reihe.appendChild(el('span', 'qbr__photos-more', '+' + (bilder.length - MAX_BILDER)));
      }
      card.appendChild(reihe);
    }

    var btn = el('button', 'qbr__more');
    btn.type = 'button'; btn.hidden = true;
    card.appendChild(btn);
    return card;
  }

  /* ---------- (Translated by Google) … (Original) … trennen ---------- */
  var TRANS_RE = /^\(Translated by Google\)\s*([\s\S]*?)\s*\(Original\)\s*[\s\S]*$/;
  function splitTranslated(raw) {
    var t = (raw || '').trim();
    var m = t.match(TRANS_RE);
    if (m) return { text: m[1].trim(), uebersetzt: true };
    return { text: t, uebersetzt: false };
  }

  /* ---------- A/B-Test 'bewertung', Arm b: Uebersetzung zuerst, Original eingeklappt ----------
     Grossjob 20261009-GROSSJOB-us-kauf-tracking-und-kundenreise-pruefen-und-bauen, s09 (Befund P4).

     WARUM: der Reputon-Feed hat sein Textformat gewechselt. Der Schnappschuss vom 2026-08-07
     (build/feed-snapshot-20260807.json) traegt "(Translated by Google) <EN> (Original) <DE>"
     (28 von 37), der Live-Feed am 2026-10-09 "<DE> (Translated by Google) <EN>" (30 von 40, dazu
     1 im alten Format und 9 ohne Uebersetzung). TRANS_RE oben kennt nur das alte Format. Beim neuen
     zeigt die Karte deshalb den Rohtext: das deutsche Original zuerst, die englische Fassung bei
     langen Texten unter der 6-Zeilen-Klammer.

     Arm a bleibt genau so (Kontrolle). Arm b zerlegt BEIDE Formate, zeigt die Uebersetzung als
     Kartentext und legt das Original eingeklappt dahinter ("Show original"). Menge, Reihenfolge
     und Filter der Karten sind in beiden Armen gleich: renderLive filtert weiter mit
     splitTranslated, nur die Karte selbst unterscheidet sich.

     NICHT HERVORHOLEN (Auftrag s09, Punkt 2: "Gesundheitsaussagen nur auf Grundlage"): eine
     Bewertung mit Heilungs- oder Krankheitsaussage bleibt auch in Arm b wie in Arm a. HEIL_RE ist
     eine Wortliste ueber Original UND Uebersetzung (nach Umlaut-Abgleich), keine Bewertung des
     Inhalts. Am Live-Feed 09.10. trifft sie 5 von 31 uebersetzten Bewertungen.

     Zuteilung und Kill-Schalter: snippets/qb-ab.liquid (TESTS.bewertung = false -> Arm a fuer alle).
     Ohne window.qbAb oder bei jedem Fehler gilt ebenfalls Arm a. */
  var TRANS_ALT_RE = /^\(Translated by Google\)\s*([\s\S]*?)\s*\(Original\)\s*([\s\S]*)$/;
  var TRANS_NEU_RE = /^([\s\S]*?)\s*\(Translated by Google\)\s*([\s\S]*)$/;
  function zerlegeUebersetzung(raw) {
    var t = (raw || '').trim();
    var m = t.match(TRANS_ALT_RE);
    if (m && m[1].trim() && m[2].trim()) return { text: m[1].trim(), original: m[2].trim(), uebersetzt: true };
    m = t.match(TRANS_NEU_RE);
    if (m && m[1].trim() && m[2].trim()) return { text: m[2].trim(), original: m[1].trim(), uebersetzt: true };
    return { text: t, original: '', uebersetzt: false };
  }

  /* Wortteile ohne Wortgrenze (deutsche Komposita: Hirntumor, Kopfschmerzen, Arzttermine),
     kurze englische Woerter mit Wortgrenze (ill, pain, heal nicht in Spain/healthy). */
  var HEIL_RE = new RegExp('(' + [
    'tumor', 'tumour', 'krebs', 'cancer', 'chemo', 'diagnos', 'krank', 'disease', 'heilung', 'geheilt',
    'rollstuhl', 'wheelchair', 'gelaehmt', 'laehmung', 'paraly', 'schmerz', 'headache', 'migraene',
    'migraine', 'uebelkeit', 'nause', 'symptom', 'therap', 'medikament', 'medizin', 'medicat', 'medicine',
    'arzt', 'aerzt', 'doctor', 'hospital', 'surgery', 'surgical', 'surgeon', 'operiert', 'chronisch',
    'chronic', 'depress', 'burnout', 'burn-out', 'panikattack', 'panic attack', 'angststoerung',
    'anxiety disorder', 'entzuendung', 'inflammat', 'arthr', 'rheuma', 'tinnitus', 'allerg', 'asthma',
    'diabet', 'blutdruck', 'bluthochdruck', 'blood pressure', 'hypertension', 'infekt', 'infection',
    'herzinfarkt', 'heart attack', 'schlaganfall', 'herzrhythmus', 'arrhythm', 'schlafstoerung',
    'schlaflosigkeit', 'insomnia', 'genesung'
  ].join('|') + ')|\\b(' + [
    'ill', 'illness', 'sick', 'sickness', 'heal', 'heals', 'healed', 'healing', 'cure', 'cured', 'cures',
    'curing', 'pain', 'pains', 'painful', 'heilen', 'heilt', 'heilte', 'genesen', 'op', 'operation',
    'operationen', 'recover', 'recovered', 'recovery', 'recovering'
  ].join('|') + ')\\b');
  function abgleichText(s) {
    return String(s || '').toLowerCase()
      .replace(/\u00e4/g, 'ae').replace(/\u00f6/g, 'oe').replace(/\u00fc/g, 'ue').replace(/\u00df/g, 'ss');
  }
  function heilAussage(z) {
    return HEIL_RE.test(abgleichText((z.text || '') + '\n' + (z.original || '')));
  }

  /* Arm b nur, wenn die A/B-Grundlage ihn zuteilt. arm() stempelt einmal je Seite und Test
     (Stempel ab_zuteilung ueber den eigenen Pixel); jeder Fehler heisst Arm a. */
  function bewertungArmB() {
    try {
      return !!(window.qbAb && typeof window.qbAb.arm === 'function' && window.qbAb.arm('bewertung') === 'b');
    } catch (e) { return false; }
  }
  var originalZaehler = 0;

  /* ---------- Ausschluss per Google-id, wie qiblanco.com ----------
     GEO M4 (Job 20261010-geo-sageo-m4-us-kundenstimmen-serverseitig): dieselbe Liste wie DE
     app/lib/googleReviewsAusschluss.server.js, Schluessel ist die stabile Google-`id` (nicht die
     wandernde hashId, Begruendung dort). Bis hierher filterte US nur per Name aus dem Section-
     Feld data-block; eine auf DE seit 2026-09-26 ausgeschlossene Rezension lief auf US live mit
     (gemessen 2026-10-10). Wirkt in beiden Armen des Tests 'bewertung' gleich.

     KEINE VERFASSERNAMEN ODER GRUENDE IN DIESER DATEI: sie wird oeffentlich ausgeliefert, und
     eine Liste, die eine Rezension verbergen soll, darf ihren Verfasser nicht selbst nennen
     (DE-Regel, homepage-bauer/pruefungen/probe_ausschluss_nicht_im_asset.py). Wer welche id ist
     und warum, steht in DE app/lib/googleReviewsAusschluss.server.js. Die Pruefung faehrt taeglich
     homepage-bauer/pruefungen/probe_ausschluss_paritaet_de_us.py (Tick review-ausschluss-naht).

     EINE QUELLE: build/gen_reviews_ssr.py liest genau diese Liste aus dieser Datei, damit der
     serverseitige Schnappschuss (snippets/qb-reviews-ssr.liquid) und der Live-Slider nie
     auseinanderlaufen. Format beibehalten: ein String-Literal je Zeile.
     Rueckweg: Eintrag entfernen. */
  var AUSSCHLUSS_GOOGLE_IDS = [
    'AbFvOqkWRIIM8yOy-0FFxmTmreXg0oH00TuOFc-QMusa9jFGJJi9RMQM0-tHrIJ0tGRAWVEdRaSt9w',
    'AbFvOqmMxYyt68DNpOEVH3QphP4lh7c9HyT9WsAtqKpVdKoB-pSR25I8g_gYvmRXeRzjYSUjmXxm'
  ];

  /* ---------- Sortier-Achse: neueste zuerst ----------
     Christian-Direktive 2026-08-13: der untere (Live-)Slider zeigt IMMER die
     neueste Bewertung zuerst. Der Reputon-Feed liefert Googles RELEVANZ-Ordnung,
     nicht die zeitliche — gemessen am Live-Feed 2026-08-13 standen auf den
     Plaetzen 1-3 "4 months ago", "7 months ago", "8 months ago", und erst auf
     Platz 4 kam "7 days ago".

     WARUM DER RELATIV-STRING DIE PRIMAERE ACHSE IST UND NICHT DER epoch:
     der `time`-epoch des Feeds weicht nachweislich von Googles eigener Anzeige
     ab. Gemessen am Live-Feed 2026-08-13: 9 von 37 Rezensionen (24 %) divergieren
     um mehr als 20 Tage, im Extremfall um 919 Tage ("Radka Kolinova" zeigt
     "6 months ago", der epoch sagt 1099 Tage). Nach epoch zu sortieren wuerde
     "Vonni Wr" (zeigt "2 months ago", epoch 528 Tage) HINTER Karten mit
     "8 months ago" schieben — also exakt den gemeldeten Fehler in neuer Gestalt
     erzeugen. Der Kunde sieht ausschliesslich den Relativ-String; er ist damit
     die einzige Achse, an der "neueste zuerst" ueberhaupt sichtbar stimmen kann.
     Der epoch bleibt Tiebreak innerhalb desselben Textbuckets (am 2026-08-13
     lagen 8 Karten auf "9 months ago") und Fallback bei unparsbarem Text.
     Dieselbe Entscheidung, dieselbe Begruendung wie DACH: app/lib/googleRating.js
     (relativZeitInTagen + Sortierung "neueste zuerst").

     Rueckweg: den .sort()-Aufruf in renderLive() entfernen — dann gilt wieder
     die Feed-Ordnung. Kein Datenformat, kein Markup, kein CSS haengt daran. */
  var REL_RE = /(a|an|\d+)\s+(minute|hour|day|week|month|year)s?\s+ago/i;
  var REL_FAKTOR = {
    minute: 1 / 1440, hour: 1 / 24, day: 1, week: 7, month: 30, year: 365
  };

  function relativeAlterTage(zeitText, epochSekunden) {
    var m = REL_RE.exec(zeitText || '');
    if (m) {
      var n = (m[1] === 'a' || m[1] === 'A' || m[1].toLowerCase() === 'an') ? 1 : parseInt(m[1], 10);
      var f = REL_FAKTOR[m[2].toLowerCase()];
      if (!isNaN(n) && f) return n * f;
    }
    if (typeof epochSekunden === 'number' && epochSekunden > 0) {
      return Math.max(0, (Date.now() / 1000 - epochSekunden) / 86400);
    }
    return 99999; // unbekanntes Alter sortiert nach hinten, nie nach vorn
  }

  /* Totale Ordnung — bewusst NICHT auf die Stabilitaet von Array#sort gebaut:
     1. sichtbares Alter aufsteigend (klein = neu = vorn)
     2. epoch absteigend (feiner Zeitgeber innerhalb desselben Textbuckets)
     3. id lexikografisch (letzter Anker, damit gleiche Eingabe = gleiche Ausgabe) */
  function neuesteZuerst(a, b) {
    return (a._alterTage - b._alterTage) || (b._zeit - a._zeit) ||
           (a._id < b._id ? -1 : a._id > b._id ? 1 : 0);
  }

  /* ---------- Live-Feed ---------- */
  function renderLive(root) {
    var track = root.querySelector('.qbr__track');
    var status = root.querySelector('.qbr__status');
    var badge = root.querySelector('.qbr__badge');
    if (!track) return;

    var shop = root.getAttribute('data-shop');
    var minLen = parseInt(root.getAttribute('data-min-len') || '40', 10);
    var minRating = parseFloat(root.getAttribute('data-min-rating') || '4');
    var maxCards = parseInt(root.getAttribute('data-max') || '30', 10);
    var block = (root.getAttribute('data-block') || '').split(',')
      .map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
    var labels = {
      labelTranslated: root.getAttribute('data-label-translated') || 'Translated by Google',
      // Ohne Wirkaussage — beschreibt nur, was das Bild IST.
      labelPhotoAlt: root.getAttribute('data-label-photo-alt') || 'Customer photo for the review by',
      labelOriginalZeigen: root.getAttribute('data-label-original-zeigen') || 'Show original',
      labelOriginalVerbergen: root.getAttribute('data-label-original-verbergen') || 'Hide original'
    };
    var armB = bewertungArmB();
    /* Serverseitige Karten (data-qb-reviews-ssr, GEO M4): das HTML traegt die Rezensionstexte
       schon, damit KI-Crawler ohne JavaScript sie lesen. Gelingt der Abruf, ersetzt der frische
       Feed sie wie bisher (Test 'bewertung' unveraendert); misslingt er, bleiben sie stehen. */
    var ssrKarten = root.hasAttribute('data-qb-reviews-ssr') && !!track.querySelector('.qbr__card');

    function fail(msg) {
      if (ssrKarten) {
        if (status) status.hidden = true;
        track.hidden = false;
        initTrack(track);
        return;
      }
      if (status) { status.textContent = msg; status.hidden = false; }
      track.hidden = true;
    }

    fetch('https://grw.reputon.com/app/storefront/widget?shop=' + encodeURIComponent(shop),
          { credentials: 'omit' })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (d) {
        var b = (d.business && d.business[0]) || {};
        var revs = d.reviews || b.reviews || [];

        // Reihenfolge: filtern -> SORTIEREN -> deckeln. Das Sortieren muss VOR
        // dem .slice() stehen: schnitte man zuerst, ordnete man nur die
        // willkuerlichen ersten maxCards der Feed-Ordnung und liesse die
        // neuesten Karten, die dahinter liegen, ganz herausfallen.
        var list = revs.filter(function (r) {
          if (r.hide) return false;
          if (AUSSCHLUSS_GOOGLE_IDS.indexOf(String(r.id || '')) !== -1) return false;
          if ((Number(r.rating) || 0) < minRating) return false;
          var nm = (r.authorName || '').toLowerCase();
          if (block.indexOf(nm) !== -1) return false;
          return splitTranslated(r.text).text.length >= minLen;
        }).map(function (r) {
          r._alterTage = relativeAlterTage(r.relativeTimeDescription, r.time);
          r._zeit = typeof r.time === 'number' ? r.time : 0;
          r._id = String(r.hashId || r.id || r.authorName || '');
          return r;
        }).sort(neuesteZuerst).slice(0, maxCards);

        if (!list.length) { fail(''); return; }

        var frag = document.createDocumentFragment();
        /* Googles KI-Zusammenfassung (business.summary.items) als ERSTE Karte, wie
           qiblanco.com (ReputonWidget.jsx AiSummaryKarte). Nur wenn die Section es
           verlangt (data-ki-zusammenfassung, Amazon-Stil-Zone, s05 2026-09-30); jede
           andere Seite bleibt unveraendert. Die Themen sind Googles eigene Worte. */
        if (root.hasAttribute('data-ki-zusammenfassung')) {
          var themen = (b.summary && Array.isArray(b.summary.items) ? b.summary.items : [])
            .map(function (t) { return typeof t === 'string' ? t.replace(/[;.\s]+$/, '').trim() : ''; })
            .filter(Boolean);
          if (themen.length) {
            var ki = el('div', 'qbr__card qbr__card--ki');
            ki.setAttribute('aria-label', root.getAttribute('data-label-ki-aria') || 'Google reviews of Qi Blanco summarized with AI');
            var kiHead = el('div', 'qbr__head');
            kiHead.appendChild(el('p', 'qbr__ki-titel', root.getAttribute('data-label-ki-titel') || 'Summary from Google'));
            kiHead.appendChild(googleIcon(20));
            ki.appendChild(kiHead);
            var ul = el('ul', 'qbr__ki-liste');
            themen.forEach(function (t) { ul.appendChild(el('li', 'qbr__ki-thema', t)); });
            ki.appendChild(ul);
            ki.appendChild(el('p', 'qbr__ki-fuss', root.getAttribute('data-label-ki-fuss') || 'Summarized with AI'));
            frag.appendChild(ki);
          }
        }
        list.forEach(function (r) {
          var s = splitTranslated(r.text);
          var original = '';
          if (armB) {
            var z = zerlegeUebersetzung(r.text);
            if (z.uebersetzt && !heilAussage(z)) {
              s = { text: z.text, uebersetzt: true };
              original = z.original;
            }
          }
          frag.appendChild(buildCard({
            name: r.authorName, foto: r.profilePhotoUrl, rating: r.rating,
            // `foto`/profilePhotoUrl = Avatar des Verfassers (37/37 Rezensionen),
            // `bilder`/images = die vom Kunden geposteten Fotos (3/37). Nie
            // verwechseln. Eintraege ohne `url` fliegen raus statt abzustuerzen;
            // `thumbnailUrl` faellt auf `url` zurueck.
            bilder: Array.isArray(r.images)
              ? r.images
                  .filter(function (b) { return b && typeof b.url === 'string' && b.url; })
                  .map(function (b) { return { url: b.url, thumb: b.thumbnailUrl || b.url }; })
              : [],
            zeit: r.relativeTimeDescription, text: s.text, uebersetzt: s.uebersetzt, original: original
          }, labels));
        });
        track.innerHTML = '';
        track.appendChild(frag);
        track.hidden = false;
        // Die Stand-Zeile datiert nur den Schnappschuss; nach dem Live-Abruf ist sie falsch.
        var stand = root.querySelector('[data-qbr-ssr-stand]');
        if (stand) stand.hidden = true;
        if (status) status.hidden = true;

        if (badge) {
          var rating = Number(b.rating) || parseFloat(badge.getAttribute('data-fallback-rating'));
          var total = Number(b.reviewsNumber) || parseInt(badge.getAttribute('data-fallback-total'), 10);
          var numEl = badge.querySelector('.qbr__badge-num');
          var starEl = badge.querySelector('.qbr__badge-stars');
          var subEl = badge.querySelector('.qbr__badge-total');
          if (numEl) numEl.textContent = rating.toFixed(1);
          if (starEl) { starEl.innerHTML = ''; starEl.appendChild(starRow(rating, 20)); }
          if (subEl) subEl.textContent = total.toLocaleString('en-US');
          if (b.url) badge.href = b.url;
          badge.hidden = false;
        }

        initTrack(track);
      })
      .catch(function () {
        // Fail-quiet: lieber kein Slider als ein leeres Geruest.
        fail('');
        if (badge) badge.hidden = false; // Badge behaelt die Fallback-Zahlen aus dem Schema
      });
  }

  /* ---------- Sterne-Klick -> Bewertungsabschnitt ----------
     Uebernahme des DACH-Mechanismus (Header.jsx + GoogleRezensionenBereich.jsx)
     nach Liquid. Auftrag Christian 2026-08-07: auf qi-blanco.com passierte beim
     Klick auf die Sterne im Kopf nichts, auf qiblanco.com funktioniert es.

     ZWEI tote Sterne-Elemente, nicht eines (gemessen 2026-08-08):
       (a) .announcement-bar .automatic-review — der Balken ganz oben, auf JEDER
           Seite, je einmal fuer Desktop und mobil. Das ist Christians
           "Kopf/Reiter" und das strukturelle Gegenstueck zu DACHs Header.jsx.
       (b) .review-scroll-button — ein <a> OHNE href im Produkt-Kaufblock
           (product-template-complete.liquid). Steht nur auf zwei Templates,
           live nur auf /products/necklace.
     Beide waren ohne jeden JS-Handler.

     AFFORDANCE NUR BEI ZIEL: verdrahtet wird ausschliesslich, wenn die
     Zielsuche auf dieser Seite wirklich etwas findet. Wo es keinen
     Bewertungsabschnitt gibt (die beiden Kakao-Seiten tragen ihn bewusst
     nicht), bleibt der Text, was er heute ist — kein Cursor, kein Fokusring,
     kein Sprung ins Nichts. DACH oeffnet an dieser Stelle ein Popup; das gibt
     es auf US nicht, deshalb hier No-Op statt Ersatzhandlung. */

  var ZIEL_IDS = ['kundenerfahrungen', 'google-rezensionen'];

  /* TRIGGER_SEL = MARKER ZUERST, Bestandsklassen als Rueckfall.

     `[data-qb-rating="s"]` ist seit Job 20260820-... s04 der eigentliche
     Vertrag: der Marker sitzt an der VERWENDUNGSSTELLE im Liquid und umfasst
     dort Zahl UND Sterne. Die beiden Bestandsklassen bleiben ausdruecklich
     stehen, damit nicht migrierte Altvorkommen nicht durchs Raster fallen —
     sie zu entfernen waere ein zweiter, unnoetiger Bruch.

     WARUM DER MARKER UEBERHAUPT NOETIG WAR (gemessen 2026-08-22, alle vier
     US-Wirte): `.announcement-bar .automatic-review` trifft die <span> mit der
     ZAHL. Die fuenf Stern-Glyphen stehen als SCHWESTER-Textknoten daneben, im
     <b> darum herum — also AUSSERHALB des Triggers. Wer auf die Sterne klickte,
     traf nichts. Ein blosses Weiten der Klassenliste heilt das nicht: das
     tragende Element muss der gemeinsame Elternknoten von Zahl und Sternen
     sein. Genau den markiert jetzt sections/header.liquid.

     Die Klasse "d" (Bewertungskarten) und "g" (Google-Badge) stehen bewusst
     NICHT hier — sie sind definiertes Verhalten, aber kein Sprung. */
  var TRIGGER_SEL = '[data-qb-rating="s"], .review-scroll-button, ' +
                    '.announcement-bar .automatic-review';
  var SCROLL_LUFT_PX = 12;

  function findeRezensionsZiel() {
    for (var i = 0; i < ZIEL_IDS.length; i++) {
      var n = document.getElementById(ZIEL_IDS[i]);
      if (n) return n;
    }
    // Letzter Rueckfall wie auf DACH. Auf US existiert diese Klasse nicht —
    // bewusst mitgefuehrt, damit die beiden Shops dieselbe Vorrangkette haben.
    return document.querySelector('.google-rating-badge');
  }

  /* Kopfhoehe LIVE messen statt hartkodieren: das Theme hat mehrere
     Kopf-Kandidaten und die Hoehe haengt an Viewport und Announcement-Bar. */
  function messeKopfHoehe() {
    var unten = 0;
    var kandidaten = document.querySelectorAll(
      'header, .header-wrapper, .announcement-bar, .site-header, .shopify-section-header'
    );
    Array.prototype.forEach.call(kandidaten, function (el) {
      var st = window.getComputedStyle(el);
      if (st.position !== 'fixed' && st.position !== 'sticky') return;
      var r = el.getBoundingClientRect();
      if (r.height <= 0) return;
      if (r.top > 5) return;              // haengt nicht oben = deckt das Ziel nicht ab
      if (r.bottom > unten) unten = r.bottom;
    });
    return unten;
  }

  /* KEINE Richtungsabfrage — und das ist eine bewusste, gemessene Abweichung
     vom DACH-Vorbild, kein Vergessen.

     DACH zieht beim Scrollen nach unten 0 ab, weil sein Kopf dabei AUSBLENDET;
     ein Abzug waere dort eine zweite Kompensation. Auf US gilt das Gegenteil:
     der Kopf ist oben relative (also gar nicht im Weg) und wird beim Scrollen
     fixed (also sehr wohl im Weg). Die DACH-Regel haelt das Ziel deshalb genau
     hinter dem Kopf fest.

     Gemessen auf /products/necklace (Desktop 1440, Kopf 90 px hoch):
       mit Richtungsabfrage   Hinweg 1922 -> Ziel bei  12 px = hinter dem Kopf
       ohne Richtungsabfrage  Hinweg 1832 -> Ziel bei 102 px = 90 + 12 sichtbar
     Der Rueckweg landete schon vorher korrekt auf 1832 — die Asymmetrie der
     beiden Richtungen WAR die Richtungsabfrage.

     Die live gemessene Kopfhoehe leistet beides zugleich: sie ist 0, solange
     der Kopf im Fluss steht, und exakt seine Hoehe, sobald er klebt. Zusammen
     mit der Konvergenz unten deckt sie DACHs Fall ebenso ab wie diesen. */
  function sollPosition(ziel) {
    var zielOben = ziel.getBoundingClientRect().top + window.scrollY;
    return Math.max(0, zielOben - messeKopfHoehe() - SCROLL_LUFT_PX);
  }

  /* WARUM HIER MEHR STEHT ALS AUF DACH — gemessen, nicht vermutet:

     Der US-Kopf wechselt beim Scrollen von position:relative auf fixed
     (theme.js schaltet ab ~45 px Scrolltiefe um). Damit faellt er aus dem
     Textfluss und ALLES darunter rutscht um seine Hoehe nach oben. Eine vor
     dem Scroll berechnete Zielposition ist danach ungueltig — egal wie richtig
     der Kopf-Ausgleich selbst war.

     Gemessen auf /products/necklace, Desktop 1440: zielOben vor dem Klick
     2071, die DACH-Rechnung ergibt 2059, die Seite landet auch dort — aber das
     Ziel steht dann bei 1934, also 137 px hoeher als berechnet, im Viewport bei
     -125 und hinter dem inzwischen fixierten Kopf.

     Gegenmittel ist keine bessere Formel, sondern eine KONVERGENZ: nach der
     Bewegung die Lage neu messen und nachjustieren. Die Nachmessung sieht den
     Kopf dann als fixed, rechnet also mit seiner echten Hoehe und trifft.

     NACHTRAG 2026-08-15 — die Konvergenz war RICHTIG GEDACHT UND FALSCH
     GETAKTET, und der Unterschied kostete die Startseite:

     Die Vorgaengerfassung korrigierte nach festen Wartezeiten (520/90/90 ms,
     4 Runden). Alle vier Runden waren damit nach ~700 ms verbraucht — waehrend
     die weiche Animation ueber 2771 px noch lief. Eine laufende
     behavior:'smooth'-Animation traegt ihr Ziel INTERN und ueberfaehrt jede
     Korrektur, die vor ihrem Ende feuert. Sie erreichte ihr urspruengliches,
     durch den Versatz laengst veraltetes Ziel und blieb dort stehen.

     GEMESSEN auf der Startseite (Zeitreihe, 1440x900):
       vor Klick  y=0     zielOben=2783  kopf=0   soll=2771
       +200 ms    y=1094  zielOben=2646  kopf=91  soll=2544   <- Versatz komplett
       +900 ms    y=2771  zielOben=2646  kopf=91  soll=2544   <- Animation endet
       ... bis +9000 ms unveraendert y=2771
     Die Runden rechneten also KORREKT (soll fiel richtig von 2771 auf 2544) —
     nur durfte niemand ihr Ergebnis noch anwenden. Ueberschuss: 125 px.

     Der Versatz ist NICHT spaetes Nachladen von Bildern: er steht bei +200 ms
     vollstaendig und bleibt danach konstant.

     WARUM DER FEHLER SO LANGE UNSICHTBAR WAR — er ist distanz-abhaengig:
       /products/necklace 1971 px -> gruen     (Animation endet im Zeitfenster)
       /products/qione    2378 px -> gruen
       /                  2783 px -> ROT
     Die Kippschwelle liegt zwischen 2378 und 2783 px, also waechst der Defekt
     mit jedem Seitenausbau von selbst nach.

     Deshalb wird jetzt auf STILLSTAND gewartet (Scrollposition ueber mehrere
     Frames konstant) und erst dann neu gemessen. Der Zeitdeckel ist nur noch
     Notbremse, kein Taktgeber: er greift, wenn der Nutzer selbst weiterscrollt
     oder eine Animation nie zur Ruhe kommt. */
  function scrolleZuRezensionen(ziel) {
    var sanft = !reducedMotion();
    var KORREKTUREN = 3;      // erster Sprung + hoechstens zwei Nachzuege
    var STILL_FRAMES = 3;     // so viele Frames ohne Bewegung = Animation fertig
    var MAX_WARTE_MS = 2500;  // Notbremse, kein Taktgeber
    var TOLERANZ_PX = 3;

    function naechsterFrame(fn) {
      if (window.requestAnimationFrame) window.requestAnimationFrame(fn);
      else setTimeout(fn, 16);
    }

    function scrollY() {
      return window.pageYOffset || window.scrollY || 0;
    }

    /* Wartet, bis sich die Scrollposition ueber STILL_FRAMES Frames nicht mehr
       bewegt — oder bis die Notbremse greift. Erst danach ist eine Neumessung
       ueberhaupt aussagekraeftig. */
    function beiStillstand(weiter) {
      var letzte = null, ruhig = 0, start = new Date().getTime();
      naechsterFrame(function tick() {
        var y = scrollY();
        if (letzte !== null && Math.abs(y - letzte) < 1) ruhig++;
        else ruhig = 0;
        letzte = y;
        if (ruhig >= STILL_FRAMES || (new Date().getTime() - start) > MAX_WARTE_MS) {
          weiter();
          return;
        }
        naechsterFrame(tick);
      });
    }

    function fahre(rest) {
      var soll = sollPosition(ziel);
      if (Math.abs(soll - scrollY()) <= TOLERANZ_PX) return;   // sitzt
      if (sanft) window.scrollTo({ top: soll, behavior: 'smooth' });
      else window.scrollTo(0, soll);
      if (rest <= 1) return;
      beiStillstand(function () { fahre(rest - 1); });
    }

    /* ZUSTAND HERSTELLEN, DANN MESSEN.

       Die Konvergenz oben LANDET richtig, aber sie tut es sichtbar: gemessen
       wurde nach dem ersten Fix auf der Startseite
         300ms y=1855 -> 1200ms y=2771 (Ueberschuss) -> 2600ms y=2544 (sitzt)
       Der Kunde faehrt also ueber die Ueberschrift hinaus und wird nach rund
       anderthalb Sekunden um 227 px zurueckgeholt. Fachlich erfuellt, unruhig.

       Der Grund ist die REIHENFOLGE, nicht die Rechnung: gemessen wird im
       ungescrollten Zustand, in dem der Kopf noch im Textfluss steht. Der
       Versatz entsteht erst DURCH das Scrollen — die erste Rechnung ist also
       zwangslaeufig veraltet, egal wie gut sie ist.

       Also wird der Zielzustand vorher hergestellt: ein winziger,
       unmittelbarer Sprung ueber die Umschaltschwelle (theme.js setzt
       .scrolling ab ~45 px), kurz warten, bis der Kopf-Handler gelaufen und
       neu umbrochen ist — und ERST DANN messen und sanft fahren. Damit
       stimmt schon der erste Zielwert und es gibt keinen Ueberschuss mehr.

       Die Konvergenz bleibt als Netz darunter: sie faengt alles, was dieser
       Vorgriff nicht kennt (spaet einlaufende Inhalte, andere Kopf-Varianten,
       kuenftige Sektionen). Der Vorgriff macht den Normalfall ruhig, das Netz
       haelt den Sonderfall richtig. */
    var UMSCHALT_PX = 60;   // knapp ueber der 45-px-Schwelle von theme.js
    var jetzt = scrollY();

    if (jetzt < UMSCHALT_PX && sollPosition(ziel) > UMSCHALT_PX) {
      window.scrollTo(0, UMSCHALT_PX);
      // Der Kopf-Handler haengt am scroll-Event (jQuery), nicht an unserem
      // Aufruf — ein Frame reicht nicht zuverlaessig, darum eine kurze,
      // unmerkliche Pause statt einer Wette auf die Ereignisreihenfolge.
      setTimeout(function () { fahre(KORREKTUREN); }, 150);
    } else {
      fahre(KORREKTUREN);
    }
  }

  function verdrahteRezensionsTrigger(scope) {
    if (!findeRezensionsZiel()) return;   // No-Op: keine Affordance ohne Ziel
    var treffer = (scope || document).querySelectorAll(TRIGGER_SEL);
    Array.prototype.forEach.call(treffer, function (t) {
      if (t.getAttribute('data-qbr-scroll') === '1') return;
      t.setAttribute('data-qbr-scroll', '1');
      t.style.cursor = 'pointer';
      if (!t.getAttribute('aria-label')) {
        t.setAttribute('aria-label', 'Jump to customer reviews');
      }
      if (t.tagName === 'A' && !t.getAttribute('href')) {
        // <a> ohne href ist weder fokussierbar noch tastaturbedienbar.
        // Das Ziel steht fest, also bekommt es einen echten Hash-Link:
        // nativ fokussierbar, Enter loest nativ ein click-Event aus.
        t.setAttribute('href', '#' + (findeRezensionsZiel().id || ZIEL_IDS[0]));
      } else if (t.tagName !== 'A') {
        if (!t.getAttribute('tabindex')) t.setAttribute('tabindex', '0');
        if (!t.getAttribute('role')) t.setAttribute('role', 'button');
      }
    });
  }

  /* Delegation am document statt Handler am Element: theme.js
     fetchReviewData() schreibt jedes .automatic-review per innerHTML neu, und
     der Theme-Editor tauscht ganze Sektionen aus. Ein delegierter Handler
     ueberlebt beides. Einmalig, auch wenn zwei Sektionen das Asset laden. */
  function verdrahteDelegation() {
    if (document.documentElement.getAttribute('data-qbr-scroll-delegiert') === '1') return;
    document.documentElement.setAttribute('data-qbr-scroll-delegiert', '1');

    function ausloesen(e, knoten) {
      if (!knoten || knoten.getAttribute('data-qbr-scroll') !== '1') return;
      var ziel = findeRezensionsZiel();
      if (!ziel) return;                  // No-Op statt Sprung ins Nichts
      e.preventDefault();                 // haelt den #hash aus der Adresszeile
      scrolleZuRezensionen(ziel);
    }

    document.addEventListener('click', function (e) {
      var knoten = e.target && e.target.closest ? e.target.closest(TRIGGER_SEL) : null;
      ausloesen(e, knoten);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
      var knoten = e.target && e.target.closest ? e.target.closest(TRIGGER_SEL) : null;
      if (!knoten) return;
      // Beim <a> feuert Enter nativ ein click — sonst liefe es doppelt.
      if (knoten.tagName === 'A' && e.key === 'Enter') return;
      ausloesen(e, knoten);
    });
  }

  /* ---------- Selbstheilung: tote Bild-Hotlinks ----------------------------
     Job 20260812-...-vollzug-ov33128e0eaf-w2 (offener Vollzug ov33128e0eaf).

     BEFUND, am 2026-09-07 live gemessen: die Design-Rubrik meldete auf
     qi-blanco.com/ "kaputte Bilder (naturalWidth 0)". Zwei davon sind echt und
     dauerhaft - die beiden KUNDENFOTOS der kuratierten Rezensionen
     (lh3.googleusercontent.com/grass-cs/...). Nachgemessen mit curl:
     HTTP 403, content-type text/html; Chrome blockt die Antwort per ORB
     (net::ERR_BLOCKED_BY_ORB) und malt das Symbol fuer ein defektes Bild.
     Die zwoelf AVATARE derselben Sektion antworten unveraendert mit 200.

     WARUM DER FIX HIER STEHT UND NICHT IN DER SEKTION: die Urteilsfaehigkeit
     ueber "laedt oder nicht" hat nur der Browser. Die Foto-URLs sind
     kurzlebige Google-Adressen - sie ablaufen zu sehen ist der NORMALFALL,
     nicht der Sonderfall, und der naechste Ablauf kommt bestimmt. Die beiden
     toten Adressen von Hand aus sections/qb-reviews-curated.liquid zu
     loeschen waere zudem am falschen Ort: die Datei ist ERZEUGT
     (build/gen_curated_section.py aus einem eingefrorenen Feed-Schnappschuss)
     und traegt oben "Nicht von Hand editieren".

     WAS ER TUT: ein einziger, delegierter Fehler-Horcher. Faellt ein Kundenfoto
     aus, verschwindet sein Kaestchen; faellt das letzte der Reihe aus,
     verschwindet die Reihe. Die Rezension selbst - Name, Sterne, Text - bleibt
     unberuehrt: der soziale Beweis haengt am Menschen, nicht am Foto.
     Der Live-Pfad (buildCard) hat fuer AVATARE bereits einen eigenen
     Rueckfall auf den Initial-Buchstaben; die statische Sektion hatte keinen,
     deshalb bekommt sie ihn hier - und nur sie, damit sich die beiden Wege
     nicht ins Gehege kommen.

     'error' an einem <img> steigt NICHT auf. Ein Horcher am document erreicht
     ihn ausschliesslich in der CAPTURE-Phase; ohne das dritte Argument `true`
     ist diese Wache still und wirkungslos - und still sieht aus wie gesund. */
  var bildWacheSteht = false;
  function bildWacheSetzen() {
    if (bildWacheSteht) return;
    bildWacheSteht = true;
    document.addEventListener('error', function (ev) {
      var img = ev.target;
      if (!img || img.nodeType !== 1 || img.tagName !== 'IMG' || !img.classList) return;

      if (img.classList.contains('qbr__photo-img')) {
        var kachel = img.closest ? img.closest('.qbr__photo') : null;
        var reihe = img.closest ? img.closest('.qbr__photos') : null;
        (kachel || img).remove();
        if (reihe && !reihe.querySelector('.qbr__photo')) reihe.remove();
        return;
      }

      if (img.classList.contains('qbr__avatar') &&
          img.closest && img.closest('.qbr[data-mode="static"]')) {
        var kopf = img.closest('.qbr__head');
        var nameEl = kopf ? kopf.querySelector('.qbr__name') : null;
        var buchstabe = ((nameEl && nameEl.textContent) || '?').trim().charAt(0).toUpperCase() || '?';
        img.replaceWith(el('div', 'qbr__avatar qbr__avatar--initial', buchstabe));
      }
    }, true);
  }

  /* Der Horcher allein genuegt NICHT, und das ist der Teil, den man beim ersten
     Bau uebersieht: ein <img> kann seinen Fehler schon geworfen haben, BEVOR
     dieses Skript ueberhaupt laeuft - es haengt mit `defer` hinter dem Parser,
     und der Browser laedt Bilder nahe am Sichtfeld waehrend des Parsens. Am
     2026-09-07 gemessen: mit Horcher allein blieben beide toten Kundenfotos
     stehen (naturalWidth 0, complete=true). Deshalb der Nachlauf ueber das,
     was schon da ist. `complete && naturalWidth === 0` ist die einzige
     rueckwirkend lesbare Spur eines fehlgeschlagenen Bildes. */
  function bildNachlauf(wurzel) {
    var w = wurzel || document;
    Array.prototype.forEach.call(
      w.querySelectorAll('.qbr__photo-img, .qbr__avatar'),
      function (img) {
        if (!img.complete) {
          // noch unterwegs: der Horcher oben faengt ihn
          return;
        }
        if (img.naturalWidth !== 0) return;
        img.dispatchEvent(new Event('error'));
      }
    );
  }

  function boot(scope) {
    bildWacheSetzen();
    (scope || document).querySelectorAll('.qbr[data-mode="live"]').forEach(renderLive);
    (scope || document).querySelectorAll('.qbr[data-mode="static"] .qbr__track').forEach(initTrack);
    // Ohne scope: der Kopf liegt ausserhalb jeder Sektion, also immer global suchen.
    verdrahteRezensionsTrigger(null);
    verdrahteDelegation();
    bildNachlauf(scope || document);
    // Zweiter Durchgang, wenn alle Ressourcen durch sind: was beim ersten noch
    // `complete === false` war, ist jetzt entschieden.
    if (document.readyState === 'complete') { bildNachlauf(scope || document); }
    else { window.addEventListener('load', function () { bildNachlauf(scope || document); }, { once: true }); }
  }

  // bildThumbUrl ist mit exportiert, damit die Abnahme-Probe die Thumb-Regel
  // messen kann, ohne die Datei nachzubauen (eine Probe, die ihre Eingabe von
  // Hand nachbaut, misst die eigene Phantasie).
  window.QBReviews = {
    initTrack: initTrack, renderLive: renderLive, boot: boot,
    bildNachlauf: bildNachlauf,
    buildCard: buildCard, bildThumbUrl: bildThumbUrl,
    // Sortier-Achse aus demselben Grund exportiert: die Abnahme-Probe soll die
    // ECHTE Sortierung gegen den echten Feed fahren, nicht eine Nachbildung.
    relativeAlterTage: relativeAlterTage,
    neuesteZuerst: neuesteZuerst,
    // Test 'bewertung' (s09) aus demselben Grund: die Probe faehrt den echten Zerleger und
    // die echte Wortliste gegen den mitgeschnittenen Live-Feed.
    splitTranslated: splitTranslated,
    zerlegeUebersetzung: zerlegeUebersetzung,
    heilAussage: heilAussage,
    // Scroll-Teil mit exportiert, aus demselben Grund: die Abnahme-Probe soll
    // den echten Kopf-Ausgleich messen koennen statt ihn nachzurechnen.
    findeRezensionsZiel: findeRezensionsZiel,
    messeKopfHoehe: messeKopfHoehe,
    sollPosition: sollPosition,
    scrolleZuRezensionen: scrolleZuRezensionen
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  // Theme-Editor: Sektion neu geladen -> erneut verdrahten
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
